var map = {
	"./1inch.webp": 9453,
	"./Bcertain wallet.webp": 5103,
	"./Binance.webp": 1272,
	"./MEW.webp": 3273,
	"./OKX.webp": 1468,
	"./Saakuru .webp": 2088,
	"./WEMIX.webp": 6104,
	"./absolute.webp": 9091,
	"./airgap.webp": 2894,
	"./argent.webp": 1719,
	"./aurora.webp": 4030,
	"./backpack.webp": 244,
	"./beewallet.webp": 3399,
	"./best.webp": 1120,
	"./bifrost.webp": 4639,
	"./bitcoindotcom.webp": 16,
	"./bitget.webp": 1735,
	"./bitpay.webp": 5533,
	"./bitso.webp": 7135,
	"./blackfort.webp": 7972,
	"./bladewallet.webp": 9861,
	"./block.webp": 23,
	"./blockchain.webp": 7548,
	"./blocto.webp": 9643,
	"./bravel.webp": 96,
	"./bridge.webp": 4811,
	"./bybit.webp": 4226,
	"./bytebank.webp": 9738,
	"./chain.webp": 503,
	"./coca.webp": 588,
	"./coinbase.webp": 4058,
	"./coinwallet.webp": 9058,
	"./coolwallet.webp": 3526,
	"./core.webp": 4257,
	"./cryptodotcom.webp": 9483,
	"./ctrl.webp": 5979,
	"./cvl walle.webp": 8706,
	"./d'cent.webp": 2261,
	"./dawn.webp": 8380,
	"./ellipal.webp": 1645,
	"./enjin.webp": 8118,
	"./exodus.webp": 9392,
	"./facewallet.webp": 3762,
	"./family.webp": 1386,
	"./fastex.webp": 2449,
	"./fireblocks.webp": 3456,
	"./fox.webp": 6139,
	"./frame.webp": 7683,
	"./frontier .webp": 8349,
	"./gamestop.webp": 4384,
	"./gm2.webp": 92,
	"./gooddollar.webp": 1889,
	"./gryfyn.webp": 9427,
	"./halo.webp": 9324,
	"./haqq.webp": 5639,
	"./here.webp": 2508,
	"./huddin.webp": 9254,
	"./imota.webp": 8846,
	"./imtoken.webp": 7685,
	"./infinity.webp": 5014,
	"./internet.webp": 2483,
	"./iopay.webp": 6500,
	"./jade.webp": 5608,
	"./jambo.webp": 8913,
	"./joyid.webp": 9829,
	"./keplir.webp": 1561,
	"./keychain.webp": 6062,
	"./kigo.webp": 7084,
	"./klip.webp": 2684,
	"./koala.webp": 648,
	"./kraken.webp": 7104,
	"./kriptomat.webp": 1491,
	"./krystal.webp": 1844,
	"./ledger.webp": 9339,
	"./linen.webp": 7270,
	"./localtrade.webp": 7897,
	"./locker.webp": 1986,
	"./lode.webp": 4548,
	"./loopring.webp": 8630,
	"./magic.webp": 9877,
	"./marble.webp": 9995,
	"./mathwallet.webp": 4529,
	"./metamask.webp": 4363,
	"./metapro.webp": 202,
	"./monarch.webp": 4400,
	"./moonpay.webp": 6759,
	"./mywallid.webp": 9833,
	"./nabox.webp": 6776,
	"./nova.webp": 7852,
	"./now.webp": 918,
	"./numio.webp": 9038,
	"./okse.webp": 2336,
	"./okto.webp": 2241,
	"./onekey.webp": 8213,
	"./onto.webp": 7074,
	"./opera.webp": 2857,
	"./other.webp": 5280,
	"./oxallus.webp": 4592,
	"./paper.webp": 2844,
	"./paybolt.webp": 5063,
	"./phantom.webp": 9403,
	"./pintu.webp": 1458,
	"./plus.webp": 1698,
	"./prema.webp": 1637,
	"./rabby.webp": 5634,
	"./rainbow.webp": 9164,
	"./ricewallet.webp": 8678,
	"./robinhood.webp": 5620,
	"./ronin.webp": 2926,
	"./sabay.webp": 1638,
	"./safe.webp": 871,
	"./safepal.webp": 9464,
	"./subwallet.webp": 5081,
	"./taho.webp": 9388,
	"./talken.webp": 375,
	"./tangem.webp": 2716,
	"./tholos.webp": 7303,
	"./thorwallet.webp": 3898,
	"./timeless.webp": 1674,
	"./tokenpocket.webp": 1265,
	"./tokoin.webp": 3782,
	"./tomi.webp": 6041,
	"./torus.webp": 3263,
	"./trust.webp": 5376,
	"./trustee.webp": 7626,
	"./u2u.webp": 2808,
	"./ultimate.webp": 1149,
	"./una.webp": 2360,
	"./uniswap.webp": 2635,
	"./unstoppable wa.webp": 8065,
	"./unstoppable.webp": 4191,
	"./uvtoken.webp": 5378,
	"./valora.webp": 947,
	"./volt.webp": 5381,
	"./wallacy.webp": 4889,
	"./wallet.webp": 2131,
	"./walletconnect.webp": 2879,
	"./wemix wallet.webp": 5801,
	"./wombat .webp": 4034,
	"./wow.webp": 5953,
	"./xcapit.webp": 1587,
	"./xellar.webp": 3658,
	"./xportal.webp": 756,
	"./zeal.webp": 6174,
	"./zengo.webp": 4845,
	"./zerion.webp": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;